import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Field, useField } from "formik";
import React from "react";
import MuiLabel from "./MuiLabel";

const PhoneInputField = (props) => {
  const { label, name, ...rest } = props;
  const [field, meta, helpers] = useField(props.name);
  
  return (
    <div>
      <MuiLabel {...props} />
      <Field name={name} {...rest}>
        {({ field }) => (
          <React.Fragment>
            <PhoneInput
              {...props}
              {...field}
              name={name}
              international
              autocompleteSearch={true}
              countryCallingCodeEditable={false}
              defaultCountry="NO"
              value={field.value}
              onBlur={() => {
                helpers.setTouched(true); // Mark field as touched on blur
              }}
              onChange={(value, country) => {
                // Just set the value without setting error immediately
                helpers.setValue(value);
                
                // Only validate if the field has been touched
                if (meta.touched) {
                  if (!country?.dialCode) {
                    helpers.setError("Please select a country code first.");
                  } else if (!value.startsWith(country.dialCode)) {
                    helpers.setError(
                      `Phone number must start with ${country.dialCode}`
                    );
                  } else {
                    helpers.setError(""); // Clear error if everything is correct
                  }
                }
              }}
              isValid={(value, country) => {
                // Don't validate until touched
                if (!meta.touched) return true;
                
                if (!country?.dialCode) {
                  return "Please select a country code first.";
                }
                if (!value.startsWith(country.dialCode)) {
                  return `Phone number must start with ${country.dialCode}`;
                }
                return true;
              }}
            />
            
            {/* Only show error if field has been touched */}
            {meta.touched && meta.error && (
              <p className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                {meta.error}
              </p>
            )}
          </React.Fragment>
        )}
      </Field>
    </div>
  );
};

export default PhoneInputField;